import { toLocalizedRiotUrl } from './../utils/language';
import history from '../../app_react/history';

const goToStart = function() {
    history.push(toLocalizedRiotUrl('/selling/'));
};

const goToSummary = function(draftId) {
    history.push(toLocalizedRiotUrl('/selling/summary/' + draftId));
};

const goToPublished = function(itemId) {
    history.push(toLocalizedRiotUrl('/selling/published/' + itemId));
};

const setDraftUrlWithoutReload = function(draftId) {
    window.history.replaceState(
        {},
        document.title,
        toLocalizedRiotUrl('/selling/draft/' + draftId)
    );
};

export default {
    goToStart,
    goToSummary,
    goToPublished,
    setDraftUrlWithoutReload
};
